import { ChevronDown } from "lucide-react";
import { useI18n } from "@/i18n";
import styles from "./LandingVisual.module.css";

const QUESTIONS = ["decision", "trial", "privacy", "security", "library", "individual"];

export function LandingFaq() {
  const { t } = useI18n();

  return (
    <section id="pertanyaan" className={styles.faq} aria-labelledby="landing-faq-title" data-testid="landing-faq">
      <div className={styles.container}>
        <div className={styles.faqLayout}>
          <div className={styles.faqIntro}>
            <p className={styles.eyebrow}>{t("landing.faq.eyebrow")}</p>
            <h2 id="landing-faq-title">{t("landing.faq.title")}</h2>
            <p className={styles.lede}>{t("landing.faq.lede")}</p>
            <div className={styles.trustNote} data-testid="landing-trust-note">
              <h3>{t("landing.trust.title")}</h3>
              <p>{t("landing.trust.body")}</p>
              <a href="/kebijakan#privasi" data-testid="landing-trust-policy">{t("landing.visual.privacy")}</a>
            </div>
          </div>
          <div className={styles.faqList}>
            {QUESTIONS.map((id) => (
              <details key={id} className={styles.faqItem} data-testid={`landing-faq-${id}`}>
                <summary data-testid={`landing-faq-${id}-toggle`}>
                  <h3>{t(`landing.faq.${id}.question`)}</h3>
                  <ChevronDown size={18} strokeWidth={1.5} aria-hidden="true" />
                </summary>
                <div className={styles.faqAnswer}>
                  <p>{t(`landing.faq.${id}.answer`)}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
